import {$http} from './index';

export const scmsService = {
  browse(info, cn) {
    const path = 'api/scms/browse';
    $http(path, info).then(res => {
      cn(res);
    });
  },

  getList(info, cn) {
    const path = 'admin/site/data/GetList';
    $http(path, info).then(res => {
      cn(res);
    });
  }
};